var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0553 23.0841V32.0691C38.0553 36.2091 34.6953 39.5691 30.5553 39.5691H17.4453C13.3053 39.5691 9.94531 36.2091 9.94531 32.0691V23.1891C11.0853 24.4191 12.7053 25.1241 14.4603 25.1241C16.3503 25.1241 18.1653 24.1791 19.3053 22.6641C20.3253 24.1791 22.0653 25.1241 24.0003 25.1241C25.9203 25.1241 27.6303 24.2241 28.6653 22.7241C29.8203 24.2091 31.6053 25.1241 33.4653 25.1241C35.2803 25.1241 36.9303 24.3891 38.0553 23.0841Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.485 7.875H19.485L18.375 18.915C18.285 19.935 18.435 20.895 18.81 21.765C19.68 23.805 21.72 25.125 24 25.125C26.31 25.125 28.305 23.835 29.205 21.78C29.475 21.135 29.64 20.385 29.655 19.62V19.335L28.485 7.875Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5396 18.405L39.1046 14.25C38.4746 9.72 36.4196 7.875 32.0246 7.875H26.2646L27.3746 19.125C27.3896 19.275 27.4046 19.44 27.4046 19.725C27.4946 20.505 27.7346 21.225 28.0946 21.87C29.1746 23.85 31.2746 25.125 33.4646 25.125C35.4596 25.125 37.2596 24.24 38.3846 22.68C39.2846 21.48 39.6896 19.965 39.5396 18.405Z",
    fill: "#473D3D",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8855 7.875C11.4755 7.875 9.43545 9.72 8.79045 14.295L8.38545 18.42C8.23545 20.025 8.67045 21.585 9.61545 22.8C10.7555 24.285 12.5105 25.125 14.4605 25.125C16.6505 25.125 18.7505 23.85 19.8155 21.9C20.2055 21.225 20.4605 20.445 20.5355 19.635L21.7055 7.89H15.8855V7.875Z",
    fill: "#473D3D",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0247 30.9904C21.1197 31.1854 19.6797 32.8054 19.6797 34.7254V39.5704H28.3047V35.2504C28.3197 32.1154 26.4747 30.6304 23.0247 30.9904Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.4341ab7bedda8847ae2683c4d6aedced.svg";
export { ForwardRef as ReactComponent };